/** Skeleton: placeholders in the final geometry, so nothing moves when the data lands. */
import type { CSSProperties } from "react";
import { cx } from "./cx";

/** A block: size it with classes (`h-6 w-16`). */
export function Skeleton({ className, style }: { className?: string; style?: CSSProperties }) {
  return <span aria-hidden className={cx("block animate-shimmer rounded bg-accent", className)} style={style} />;
}

/** One line of text: a bar the height of the glyphs inside a line box of `leading` (a class). */
export function SkeletonText({ width = "8ch", className }: { width?: string | number; className?: string }) {
  return (
    <span aria-hidden className={cx("inline-flex h-[1em] items-center align-middle", className)} style={{ width }}>
      <Skeleton className="h-[0.7em] w-full" />
    </span>
  );
}

/** A DataTable before its rows: the header bar and `rows` rows of `columns` cells (the last of four shows from `sm`) at the table's own heights. */
export function TableSkeleton({ rows = 8, columns = 4, label, className }: { rows?: number; columns?: 3 | 4; label: string; className?: string }) {
  return (
    <div role="status" aria-busy="true" aria-label={`Loading ${label}`} className={className}>
      <div className="h-10 rounded-lg border-hair border-rule-soft bg-secondary" />
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="flex h-12 items-center gap-6 border-b border-rule px-4">
          <Skeleton className="h-3" style={{ width: 120 + ((i * 37) % 80) }} />
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-3 w-24" />
          {columns === 4 && <Skeleton className="hidden h-3 w-16 sm:block" />}
        </div>
      ))}
    </div>
  );
}
